var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quota-statement"},[_c('SimpleLayout',{attrs:{"viewComponent":"quota-statement-tab","cardInfo":this.cardInfo,"leftAction":this.leftAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }